import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from "react-router-dom";
import '../Login.css';
import govtEmblem from '../../../assets/images/wb_logo.png';
import { generateFCMToken } from "../../../firebase";

function Login() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (loading) return; // prevent multiple clicks
    setLoading(true);

    try {
      const device_id = await generateFCMToken();
      console.log("Device ID:", device_id);

      const response = await axios.post(
        "https://sutmmg.codydeasoftech.in/api/login",
        { username, password, fcm_token: device_id, device_type: "Web" }
      );

      if (response.data.status === true) {
        const { user, token } = response.data.data;

        if (user.user_type_id === 2 || user.user_type_id === 4) {
          setLoading(false);
          Swal.fire({
            title: "Login Failed",
            text: "Wrong User ID or Password.",
            icon: "error",
            confirmButtonText: "OK",
            allowOutsideClick: true,
            allowEscapeKey: true
          });
          return;
        }

        Swal.fire({
          title: "Login Successful",
          text: response.data.message,
          icon: "success",
          timer: 1500,
          showConfirmButton: false
        });

        localStorage.setItem("token", token);
        localStorage.setItem("userId", user.user_id);
        localStorage.setItem("userTypeId", user.user_type_id);
        localStorage.setItem("username", user.username);
        localStorage.setItem("name", user.name);

        if (user.user_type_id === 3) {
          localStorage.setItem("vendor_id", user.user_id);
        }

        setTimeout(() => {
          navigate("/app/dashboard");
        }, 1200);
      } else {
        setLoading(false);
        Swal.fire({
          title: "Login Failed",
          text: response.data.message,
          icon: "error"
        });
      }
    } catch (error) {
      setLoading(false);
      console.error("Login Failed", error?.response?.data);
      Swal.fire({
        title: "Login Failed",
        text: error?.response?.data?.message || "Server error occurred.",
        icon: "error"
      });
    }
  };

  return (
    <div className="login-container">
      <form className="login-card" onSubmit={handleSubmit}>
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <img
            src={govtEmblem}
            style={{ width: "100px", cursor: "pointer" }}
            onClick={() => navigate("/landing")}
            alt="logo"
          />
          <h4 style={{ fontWeight: "bold" }}>
            Smart Urban Uniform Management System
          </h4>
          <p style={{ fontSize: "14px" }}>Sponsored by WB State Govt.</p>
          <p className="fw-bold" style={{ fontSize: "20px", color: "#3e7ff6" }}>SUDA LOGIN</p>
        </div>

        <div className="input-wrapper">
          <span className="icon"><i className="fas fa-envelope"></i></span>
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            disabled={loading}
          />
        </div>

        <div className="input-wrapper" style={{ position: 'relative' }}>
          <span className="icon"><i className="fas fa-key"></i></span>
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            disabled={loading}
          />
          <span className="toggle-password" onClick={() => setShowPassword(!showPassword)}>
            <i className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
          </span>
        </div>

        <button
          type="submit"
          disabled={loading}
          style={{
            cursor: loading ? "not-allowed" : "pointer",
            opacity: loading ? 0.7 : 1,
            transition: "all 0.3s ease"
          }}
        >
          {loading ? (
            <span>
              <i className="fas fa-spinner fa-pulse me-2"></i> Logging in...
            </span>
          ) : (
            "Login"
          )}
        </button>

        {/* Optional: Add a full-page overlay loader */}
        {loading && (
          <div style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999
          }}>
            <div style={{
              backgroundColor: "white",
              padding: "20px 40px",
              borderRadius: "10px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "10px",
              boxShadow: "0 4px 15px rgba(0,0,0,0.2)"
            }}>
              <div className="spinner-border text-primary" role="status" style={{ width: "3rem", height: "3rem" }}>
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mb-0 fw-bold">Authenticating...</p>
            </div>
          </div>
        )}
      </form>
    </div>
  );
}

export default Login;
